import { Link, useParams } from "react-router-dom";
import { DEFAULT_LOCALE } from "../../i18n/locales";
import MarkdownContent from "../../components/markdown/MarkdownContent";
import React from "react";
import Share from "../../components/share/Share";
import content from "../../generated/content.json";
import { useLocale } from "../../i18n/LocaleProvider";
import { useT } from "../../i18n/useT";

const BlogPost = () => {
  const { lang } = useLocale();
  const t = useT();
  const { slug } = useParams();
  const localized = (content.blog?.[lang] || []).find((p) => p.slug === slug);
  const fallback = (content.blog?.[DEFAULT_LOCALE] || []).find(
    (p) => p.slug === slug
  );
  const post = localized || fallback;

  if (!post) {
    return (
      <section className="container py-5 mt-5">
        <h1>{t("blog.notFound")}</h1>
        <p>
          <Link to={`/${lang}/blog`}>{t("blog.backToList")}</Link>
        </p>
      </section>
    );
  }

  return (
    <section className="container py-5 mt-5">
      {!localized && (
        <div className="alert alert-info">{t("blog.translationMissing")}</div>
      )}
      <h1>{post.frontmatter.title}</h1>
      <div className="text-secondary mb-4">{post.frontmatter.date}</div>
      <MarkdownContent html={post.html} />
      <Share
        path={`/${lang}/blog/${post.slug}`}
        title={post.frontmatter.title}
        heading={t("blog.shareTitle")}
      />
      <p className="mt-5">
        <Link to={`/${lang}/blog`}>{t("blog.backToList")}</Link>
      </p>
    </section>
  );
};

export default BlogPost;
